const COUNT_FORMATTER = new Intl.NumberFormat('pl')

export function formatCount(value: number): string {
  return COUNT_FORMATTER.format(value)
}
